import { Fragment } from "react"
import { useSelector } from "react-redux"

export default function Info({ certificate_type, project, setStep, isValid }) {

    const CMS = useSelector((state) => state.CMS)
    const user = project.applicants.find((a) => a.is_captain)?.user

    return (
        <Fragment>
            <div className="text-[1.5rem] font-semibold mb-2">
                {certificate_type?.label}
                {certificate_type?.shortcut === 'award' && '獲獎證明'} 申請
            </div>
            <div className="text-[0.875rem] text-black-700 font-light mb-1">
                申請者帳號（收件信箱）
            </div>
            <div className="mb-4">
                {user.name} ({user.email})
            </div>
            <div className="text-[0.875rem] text-black-700 font-light mb-1">
                申請作品
            </div>
            <div className="mb-4">
                #{project.serial_no} {project.project_name}
            </div>
            <div className="text-[0.875rem] text-black-700 font-light mb-1">
                申請證書類別
            </div>
            <div className="mb-6">
                {certificate_type?.label}
                {certificate_type?.shortcut === 'award' && ' 獲獎證明'}
            </div>
            <div className="text-[1.125rem] font-semibold mb-2">
                申請須知與流程說明
            </div>
            <ol className="list-decimal text-[0.875rem] text-black-700 font-light leading-[1.375rem] mb-9">
                <li>
                    確認證明文件／獎狀內容資訊無誤後送出證明文件申請。或申請「變更資訊」再送出申請。
                </li>
                <li>
                    送出申請後，請靜待流程作業完成將寄至指定信箱。
                    <ul className="list-disc my-0">
                        <li>
                            同一作品不同證明文件／獎狀需要個別送出申請。
                        </li>
                        <li>
                            有申請變更內容的證明文件／獎狀需要等候人工審核，所需時間會較久，請耐心等候。
                        </li>
                        <li>
                            如有疑問請聯繫服務信箱 <a className="underline" href={`mailto:${CMS.registries['cms.home.footer.email']}}`}>{CMS.registries['cms.home.footer.email']}</a>
                        </li>
                    </ul>
                </li>
            </ol>
            <button
                type="button"
                className="w-full btn-black btn-round mb-3"
                onClick={() => {
                    if (!isValid) {
                        setStep('update')
                    }
                    else {
                        setStep('confirm')
                    }
                }}
            >下一步</button>
            <button
                type="button"
                className="w-full btn-outline-black btn-round"
                onClick={() => { setStep(null) }}
            >返回</button>
        </Fragment>
    )
}